import {ACTION_LOCATIONS} from '@helpers/analytics/events'
import getPathname from '@helpers/router/getPathname'
import {useRouter} from 'next/router'

export default function useAnalyticLocation(eventType) {
  const router = useRouter()
  const currentPath = getPathname(router)
  return ACTION_LOCATIONS[eventType]?.[currentPath] ?? null
}
